import React, {useState} from "react";
import Button from '@mui/material/Button';
import TextCard from "../../../../../../../components/TextComps/TextCard";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import { TextStruct } from "./TextStruct";
import { SourcesStruct } from "./SourcesStruct";

export default function Dia_Struct() {

const [open, setOpen] = useState(false);
const handleOpen = () => {setOpen(true);};
const handleClose = () => {setOpen(false);};

return(
<>      
  <Button onClick={handleOpen} variant="text" sx={{textTransform: 'none'}}>
    <TextCard 
            textcard={'Structural Variants'  }
           />
    </Button>

<CustomDialog open={open} onClose={handleClose}

  title='Obesity - Structural Variants'

  content={<TextStruct />}

  sources={<SourcesStruct />}

/>
</>
)}